import React, { useEffect, useState } from 'react';
import { api } from '../services/api';

export function RequestList({ userId, isAdmin }: { userId: string; isAdmin: boolean }) {
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [votingId, setVotingId] = useState('');

  useEffect(() => {
    api.getRequests(filter || undefined).then(d => { setRequests(d.requests || []); setLoading(false); });
  }, [filter]);

  const handleVote = async (requestId: string) => {
    setVotingId(requestId);
    try {
      const result = await api.vote(requestId, userId);
      if (result.action === 'voted') {
        setRequests(prev => prev.map(r => r.id === requestId ? { ...r, votes: r.votes + 1 } : r));
      }
    } catch (e: any) {
      if (e.message.includes('409')) {
        alert('Vous avez deja vote pour cette demande');
      } else {
        alert(e.message);
      }
    }
    setVotingId('');
  };

  const handleValidate = async (requestId: string) => {
    try {
      await api.updateStatus(requestId, 'validated');
      setRequests(prev => prev.map(r => r.id === requestId ? { ...r, status: 'validated' } : r));
    } catch (e: any) { alert(e.message); }
  };

  const statusColors: Record<string, { bg: string; color: string }> = {
    submitted:   { bg: '#fff8e1', color: '#f57f17' },
    validated:   { bg: '#e3f2fd', color: '#1565c0' },
    in_progress: { bg: '#e8f5e9', color: '#2e7d32' },
    done:        { bg: '#f5f5f5', color: '#616161' },
  };

  const statusLabels: Record<string, string> = {
    submitted: 'Soumise', validated: 'Validee', in_progress: 'En cours', done: 'Terminee'
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>Demandes d'evolution</h2>
        <div style={{ display: 'flex', gap: 6 }}>
          {['', 'submitted', 'validated', 'in_progress', 'done'].map(f => (
            <button key={f} onClick={() => { setFilter(f); setLoading(true); }}
              style={{
                padding: '4px 12px', borderRadius: 4, border: 'none', cursor: 'pointer', fontSize: 12,
                background: filter === f ? '#0078d4' : '#e0e0e0', color: filter === f ? '#fff' : '#333',
              }}>
              {f ? statusLabels[f] : 'Toutes'}
            </button>
          ))}
        </div>
      </div>

      {loading ? <div>Chargement...</div> : requests.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 40 }}>Aucune demande</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {requests.map(r => {
            const sc = statusColors[r.status] || statusColors.submitted;
            return (
              <div key={r.id} style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', gap: 16 }}>
                {/* Vote column */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 60 }}>
                  <button onClick={() => handleVote(r.id)} disabled={votingId === r.id}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#0078d4' }}>
                    &#9650;
                  </button>
                  <span style={{ fontSize: 24, fontWeight: 'bold', color: '#333' }}>{r.votes}</span>
                  <span style={{ fontSize: 11, color: '#999' }}>votes</span>
                </div>

                {/* Content */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <h3 style={{ margin: 0, fontSize: 16 }}>{r.title}</h3>
                    <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 'bold', background: sc.bg, color: sc.color }}>
                      {statusLabels[r.status] || r.status}
                    </span>
                    {r.category && <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#f0f0f0', color: '#666' }}>{r.category}</span>}
                  </div>
                  <p style={{ margin: '8px 0 0', fontSize: 14, color: '#555' }}>{r.description}</p>
                  <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                    Soumis par {r.submittedByUpn || 'Anonyme'} le {r.submittedAt ? new Date(r.submittedAt).toLocaleDateString('fr-FR') : ''}
                  </div>
                </div>

                {/* Admin actions */}
                {isAdmin && r.status === 'submitted' && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button onClick={() => handleValidate(r.id)}
                      style={{ padding: '6px 16px', borderRadius: 4, border: 'none', background: '#1e7e34', color: '#fff', cursor: 'pointer', fontSize: 13 }}>
                      Valider
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
